import { Action } from 'redux';
import { OrderedMap } from 'immutable';
import { Moment } from 'moment';
import * as moment from 'moment';

import {
    GET_PLACES_REQUEST,
    GET_PLACES_RESPONSE,
    GET_PLACES_ERROR,

    GET_PRICES_REQUEST,
    GET_PRICES_RESPONSE,
    GET_PRICES_ERROR,

    GET_COORDS_PLACES_FROM_REQUEST,
    GET_COORDS_PLACES_FROM_RESPONSE,
    GET_COORDS_PLACES_FROM_ERROR,

    GET_COORDS_PLACES_TO_REQUEST,
    GET_COORDS_PLACES_TO_RESPONSE,
    GET_COORDS_PLACES_TO_ERROR,

    REQUEST_LOG_REQUEST,
    REQUEST_LOG_RESPONSE,
    REQUEST_LOG_ERROR,

    ORDER_TRANSFER_REQUEST,
    ORDER_TRANSFER_RESPONSE,
    ORDER_TRANSFER_ERROR,

    GET_PAY_URL_REQUEST,
    GET_PAY_URL_RESPONSE,
    GET_PAY_URL_ERROR,

    CHECK_TIME_REQUEST,
    CHECK_TIME_RESPONSE,
    CHECK_TIME_ERROR,

    SET_PLACE_FROM,
    SET_PLACE_TO,

    SET_PLACE_FROM_INPUT,
    SET_PLACE_TO_INPUT,
    
    RESET_PLACES,
    
    SET_PRICE,

    SET_COMMENT,
    SET_TABLE,

    SET_DATE,
    SET_DEPARTURE_DATE,

    SET_PASSENGERS,
    ADD_PASSENGERS,
    SET_ARRIVAL_NUMBER,
    SET_DEPARTURE_NUMBER,
    SET_ARRIVAL_TRAIN_CARRIAGE_NUMBER,
    SET_DEPARTURE_TRAIN_CARRIAGE_NUMBER
} from '../../actions/Transfer/transfer';

import { Place } from '../../models/Transfer/Place';
import { Price } from '../../models/Transfer/Price';
import { CoordsPlace } from '../../models/Transfer/CoordsPlace';
import { Transaction } from '../../models/Transfer/Transaction';
import { Passenger } from '../../models/Transfer/Order';

export interface TransferState {
    places: OrderedMap<string, Place>;
    loadingPlaces: boolean;
    errorPlaces: any;

    coordsFrom: CoordsPlace;
    coordsTo: CoordsPlace;

    prices: OrderedMap<number, Price>;
    loadingPrices: boolean;
    errorPrices: any;

    checkTime: boolean;
    loadingCheckTime: boolean;
    errorCheckTime: string | null;

    transaction: Transaction;
    loadingTransaction: boolean;
    errorTransaction: any;

    payUrl: string;
    loadingPayUrl: boolean;
    errorPayUrl: any;

    placeFrom: Place;
    placeTo: Place;

    placeFromInput: string;
    placeToInput: string;

    price: Price;

    table: string;
    comment: string;
    date: Moment;
    departureDate: Moment;

    passengers: OrderedMap<number, Passenger>;
    countOfPassengers: number;
    departureNumber: string;
    departureTrainCarriageNumber: string;
    arrivalNumber: string;
    arrivalTrainCarriageNumber: string;
}

const initialState: TransferState = {
    places: OrderedMap<string, Place>(),
    loadingPlaces: false,
    errorPlaces: null,

    coordsFrom: {} as CoordsPlace,
    coordsTo: {} as CoordsPlace,

    prices: OrderedMap<number, Price>(),
    loadingPrices: false,
    errorPrices: null,

    checkTime: false,
    loadingCheckTime: false,
    errorCheckTime: null,

    transaction: {} as Transaction,
    loadingTransaction: false,
    errorTransaction: null,

    payUrl: '',
    loadingPayUrl: false,
    errorPayUrl: null,

    placeFrom: {} as Place,
    placeTo: {} as Place,

    placeFromInput: '',
    placeToInput: '',
    
    price: {} as Price,

    table: '',
    comment: '',
    date: moment().add(2, 'hours').add(10, 'minutes'),
    departureDate: moment().add(3, 'hours').add(10, 'minutes'),

    passengers: OrderedMap<number, Passenger>().set(0, {
        name: '',
        phone: '',
        email: ''
    }),
    countOfPassengers: 1,
    departureNumber: '',
    arrivalNumber: '',
    departureTrainCarriageNumber: '',
    arrivalTrainCarriageNumber: ''
};

export function transfer(state: TransferState = initialState, action: Action) {
    switch (action.type) {
        case GET_PLACES_REQUEST: {
            return {
                ...state,
                loadingPlaces: true,
                errorPlaces: initialState.errorPlaces
            };
        }
        case GET_PLACES_RESPONSE: {
            const result: Array<Place> = (action as any).response.result;
            const places = result.reduce((prev, cur) => prev.set(cur.id, cur), initialState.places);
            return {
                ...state,
                loadingPlaces: false,
                places
            };
        }
        case GET_PLACES_ERROR: {
            return {
                ...state,
                loadingPlaces: false,
                errorPlaces: (action as any).error
            };
        }

        case GET_COORDS_PLACES_FROM_REQUEST: {
            return {
                ...state
            };
        }
        case GET_COORDS_PLACES_FROM_RESPONSE: {
            const coordsFrom: CoordsPlace = (action as any).response.result.point;
            return {
                ...state,
                coordsFrom
            };
        }
        case GET_COORDS_PLACES_FROM_ERROR: {
            return {
                ...state
            };
        }

        case GET_COORDS_PLACES_TO_REQUEST: {
            return {
                ...state
            };
        }
        case GET_COORDS_PLACES_TO_RESPONSE: {
            const coordsTo: CoordsPlace = (action as any).response.result.point;
            return {
                ...state,
                coordsTo
            };
        }
        case GET_COORDS_PLACES_TO_ERROR: {
            return {
                ...state
            };
        }

        case GET_PRICES_REQUEST: {
            return {
                ...state,
                loadingPrices: true,
                errorPrices: initialState.errorPrices
            };
        }
        case GET_PRICES_RESPONSE: {
            const result: Array<Price> = (action as any).response.result;
            const prices = result.reduce((prev, cur) => prev.set(cur.price_id, cur), initialState.prices);
            return {
                ...state,
                loadingPrices: false,
                prices
            };
        }
        case GET_PRICES_ERROR: {
            return {
                ...state,
                loadingPrices: false,
                errorPrices: (action as any).error
            };
        }

        case REQUEST_LOG_REQUEST: {
            return {
                ...state
            };
        }
        case REQUEST_LOG_RESPONSE: {
            return {
                ...state
            };
        }
        case REQUEST_LOG_ERROR: {
            return {
                ...state
            };
        }

        case CHECK_TIME_REQUEST: {
            return {
                ...state,
                loadingCheckTime: true,
                errorCheckTime: null
            };
        }
        case CHECK_TIME_RESPONSE: {
            const result = (action as any).response.result;
            return {
                ...state,
                checkTime: result.allow_booking,
                errorCheckTime: result.notice,
                loadingCheckTime: false
            };
        }
        case CHECK_TIME_ERROR: {
            return {
                ...state,
                loadingCheckTime: false,
                errorCheckTime: (action as any).error,
                checkTime: false
            };
        }

        case ORDER_TRANSFER_REQUEST: {
            return {
                ...state,
                loadingTransaction: true,
                errorTransaction: initialState.errorTransaction
            };
        }
        case ORDER_TRANSFER_RESPONSE: {
            const result: Array<Transaction> = (action as any).response.result;
            const transaction = result[0];
            return {
                ...state,
                loadingTransaction: false,
                transaction
            };
        }
        case ORDER_TRANSFER_ERROR: {
            return {
                ...state,
                loadingTransaction: false,
                errorTransaction: (action as any).error
            };
        }

        case GET_PAY_URL_REQUEST: {
            return {
                ...state,
                loadingPayUrl: true,
                errorPayUrl: initialState.errorTransaction
            };
        }
        case GET_PAY_URL_RESPONSE: {
            const payUrl: string = (action as any).response.result.url;
            return {
                ...state,
                loadingPayUrl: false,
                payUrl
            };
        }
        case GET_PAY_URL_ERROR: {
            return {
                ...state,
                loadingPayUrl: false,
                errorPayUrl: (action as any).error
            };
        }
        case SET_PLACE_FROM: {
            return {
                ...state,
                placeFrom: (action as any).place,
                placeTo: initialState.placeTo
            };
        }
        case SET_PLACE_TO: {
            return {
                ...state,
                placeTo: (action as any).place
            };
        }

        case SET_PLACE_FROM_INPUT: {
            return {
                ...state,
                placeFromInput: (action as any).input
            };
        }
        case SET_PLACE_TO_INPUT: {
            return {
                ...state,
                placeToInput: (action as any).input
            };
        }

        case RESET_PLACES: {
            return {
                ...state,
                places: initialState.places
            };
        }
        
        case SET_PRICE: {
            return {
                ...state,
                price: (action as any).price
            };
        }

        case SET_COMMENT: {
            return {
                ...state,
                comment: (action as any).comment
            };
        }
        case SET_TABLE: {
            return {
                ...state,
                table: (action as any).table
            };
        }

        case SET_DATE: {
            return {
                ...state,
                date: (action as any).date
            };
        }
        case SET_DEPARTURE_DATE: {
            return {
                ...state,
                departureDate: (action as any).departureDate
            };
        }
        case SET_PASSENGERS: {
            return {
                ...state,
                passengers: (action as any).passengers
            };
        }
        case SET_DEPARTURE_NUMBER: {
            return {
                ...state,
                departureNumber: (action as any).departureNumber
            };
        }
        case SET_ARRIVAL_NUMBER: {
            return {
                ...state,
                arrivalNumber: (action as any).arrivalNumber
            };
        }
        case ADD_PASSENGERS: {
            return {
                ...state,
                countOfPassengers: state.countOfPassengers + 1
            };
        }
        case SET_ARRIVAL_TRAIN_CARRIAGE_NUMBER: {
            return {
                ...state,
                arrivalTrainCarriageNumber: (action as any).trainCarriageNumber
            };
        }
        case SET_DEPARTURE_TRAIN_CARRIAGE_NUMBER: {
            return {
                ...state,
                departureTrainCarriageNumber: (action as any).trainCarriageNumber
            };
        }
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/reducers/Transfer/transfer.ts